import { Link } from 'react-router-dom'
import styles from './ErrorComponent.module.scss'

function ErrorComponent({ errorMessage, renderProps = null }) {
  return (
    <div className={styles.errorContainer}>
      <div className="mx-auto flex flex-col items-center">
        {renderProps ? (
          renderProps()
        ) : (
          <>
            <span>{errorMessage}</span>
            <Link to={'/'}>Go to Home Page</Link>
          </>
        )}
      </div>
    </div>
  )
}

export default ErrorComponent
